import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { SubscriptionServiceTypeCodeText } from '../../data/common';
import Barcode from 'react-barcode';
import { formatNumberComma } from '../../Util/Util';
import { Alert } from '@material-ui/lab';
import { Button } from '@material-ui/core';
import { isArray, parseInt } from 'lodash';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(5, 2, 2, 2),
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    border: '2px solid #eee',
    textAlign: 'left',
  },
  header: {
    fontSize: '1.2rem',
    fontWeight: '600',
    position: 'relative',
    borderBottom: '1px solid #eee',
  },
  headerImage: {
    position: 'absolute',
    top: '-40px',
    right: '0',
    width: '60px',
    height: '60px',
    objectFit: 'cover',
  },
  headerDescription: {
    fontSize: '0.8rem',
    color: '#888',
  },
  barcodeAndPrice: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '1.2rem',
    fontWeight: '500',
    margin: theme.spacing(2, 0),
  },
  price: {
    color: '#333',
    fontWeight: '600',
    fontSize: '1.5rem',
    marginLeft: theme.spacing(1),
  },
  actionBtns: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-around',
    alignItems: 'stretch',
    gap: '60px',
    margin: '24px 0',
  },
  actionBtn: {
    height: '60px',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
  },
  contentItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: theme.spacing(1),
    backgroundColor: '#f5f5f5',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    fontSize: '0.8rem',
    fontWeight: '500',
    color: '#897b7b',
  },
  contentItemValue: {
    fontSize: '1rem',
    fontWeight: '500',
    color: '#333',
  },
}));

const SubscriptionServiceCard = (props) => {
  const {
    service,
    isPayingMember,
    cancelSelected,
    subscriptionActive,
    isLoading,
  } = props;
  const classes = useStyles();

  const handleCancelSelected = () => {
    cancelSelected();
  };

  const handleSubscription = () => {
    subscriptionActive(service.id);
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        {service.imageUrl && (
          <img src={service.imageUrl} className={classes.headerImage} />
        )}
        <div>{service.serviceName}</div>
      </div>
      <div className={classes.headerDescription}>
        {SubscriptionServiceTypeCodeText[service.typeCode]
          ? SubscriptionServiceTypeCodeText[service.typeCode]
          : service.typeCode}
      </div>
      <div>
        <div className={classes.content}>
          <div className={classes.contentItem}>
            <div className={classes.contentItemValue}>
              {service.subscriptionDays} 天
            </div>
            <div>訂閱天數</div>
          </div>

          {!!service.freeEntryMinutes &&
            parseInt(service.freeEntryMinutes, 10) > 0 && (
              <div className={classes.contentItem}>
                <div className={classes.contentItemValue}>
                  {service.freeEntryMinutes} 分
                </div>
                <div>免費進場分鐘</div>
              </div>
            )}
        </div>

        {isArray(service.dailyItemList) && service.dailyItemList.length > 0 && (
          <div
            className={classes.contentItem}
            style={{ alignItems: 'flex-start' }}>
            <div>每日領取</div>
            <div>
              {service.dailyItemList.map((item, index) => {
                return (
                  <div key={index}>
                    <div className={classes.contentItemValue}>
                      {item.itemName}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        <div className={classes.barcodeAndPrice}>
          <Barcode
            height={30}
            fontSize={16}
            value={
              isPayingMember ? service.payingMemberBarcode : service.barcode
            }
            width={1}
          />

          <div>
            {isPayingMember ? 'VIP會員' : '普通會員'}
            <span className={classes.price}>
              ${' '}
              {formatNumberComma(
                isPayingMember ? service.payingMemberPrice : service.price,
              )}
            </span>
          </div>
        </div>

        <Alert
          severity="error"
          style={{
            textAlign: 'left',
            backgroundColor: '#000',
            color: '#fff',
          }}>
          請務必在POS機上結帳後，按『訂閱』按鈕，才能完成訂閱服務。
        </Alert>

        <div className={classes.actionBtns}>
          <Button
            className={classes.actionBtn}
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            disabled={isLoading}
            onClick={handleSubscription}>
            訂閱
          </Button>

          <Button
            className={classes.actionBtn}
            variant="contained"
            color="default"
            size="large"
            fullWidth
            disabled={isLoading}
            onClick={handleCancelSelected}>
            重選
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionServiceCard;
